import { FunctionComponent, useContext, useState, useEffect } from "react";

import { TransferContext } from "../../../context/TransferContext";

import ScrollableContainer from "../../../layout/scrollable-container";
import Footer from "../../../components/footer";
import { ListContainer, ListItem } from "../../../components/list/List";
import Container from "../../../layout/container";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import NumberIcon from "../../../components/icons/number-icon";
import HeadingContainer from "../../../layout/heading-container";
import { TitleLarge } from "../../../components/font";
import { Button } from "@manifesthhqinc/ui-library";
import { AppContext } from "../../../context/AppContext";

export const TRANSFER_IN = "transfer-in";

const TransferInfoPane: FunctionComponent = () => {
  const [showButton, setShowButton] = useState<boolean>(false);
  const { flow } = useContext(AppContext);

  const { startTransferScreen } = useContext(TransferContext);

  useEffect(() => {
    setTimeout(() => setShowButton(true), 2500);
  }, []);

  return (
    <TransitionWrapper>
      <ScrollableContainer name="transfer-info-pane-content">
        <Container>
          <HeadingContainer withProgressBar={false} paneVariant="list">
            <TitleLarge $textAlign="center">Our transfer process:</TitleLarge>
          </HeadingContainer>
          <ListContainer name="consent-pane-transfer-in-list" className="consent-pane__list-group">
            <ListItem
              heading={"Locate old account"}
              icon={<NumberIcon iconNumber="1" />}
              body={
                flow === "Annuity"
                  ? "Confirm the account that will be used to fund your annuity."
                  : "Manifest will help you hunt down your old accounts."
              }
              iconSpacing="42"
              paddingLeft="18"
              paddingRight="28"
              className="consent-pane__list-group__item"
              size="large"
            />
            <ListItem
              heading={"Review transfer details"}
              icon={<NumberIcon iconNumber="2" />}
              body={"Manifest runs 25+ checks on your accounts to ensure the transfer goes smoothly."}
              iconSpacing="42"
              paddingLeft="18"
              paddingRight="28"
              className="consent-pane__list-group__item"
              size="large"
            />
            <ListItem
              heading={"Connect with transfer specialist"}
              icon={<NumberIcon iconNumber="3" />}
              body={
                "Once you initiate your transfer, we'll have a dedicated transfer specialist ready to assist with any queries."
              }
              iconSpacing="42"
              paddingLeft="18"
              paddingRight="28"
              className="consent-pane__list-group__item"
              size="large"
            />
          </ListContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        {showButton && (
          <Button name="getStarted" onClick={startTransferScreen} className="drop-in-item" size="large">
            Get started
          </Button>
        )}
      </Footer>
    </TransitionWrapper>
  );
};

export default TransferInfoPane;
